import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import TitleComponent from "../../components/title/Title";
import { DashboardImage, DCard, TruckTick } from "../../images/Images";
import DashboardCard from "../../components/dashboard-cards/DashboardCards";
import TrendChart from "../../components/charts/TrendChart";
import DonutChart from "../../components/charts/DonurtCharts";
import DashboardRank from "../../components/dashboard-cards/DashboardRank";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../state/store";
import { clearUser, fetchUserProfile } from "../../state/userSlice";
import useAuth from "../../state/useAuth";
import { logout } from "../../state/authSlice";
import GuageChart from "../../components/charts/Guage";
import axiosInstance from "../../axiosInstance";

interface CardItem {
  text: string;
  figure: number | string;
  img: string;
}

const Dashboard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { token, business_type, isLoggedIn } = useAuth();

  // Dashboard data state
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  // Fetch dashboard data
  useEffect(() => {
    const fetchDashboard = async () => {
      setLoading(true);
      try {
        const res = await axiosInstance.get("/analytics/dashboard/venture");
        if (res.data?.valid) {
          setDashboardData(res.data.data);
        }
      } catch (error) {
        setDashboardData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchDashboard();
    checkUserStatus();
    checkVentureState();
    getUserStatus();
  }, []);

  const checkVentureState = async () => {
    try {
      const res = await axiosInstance.get("/ventures/me");
      if (!res.data.data) {
        window.location.href = "/create-business";
        // console.log(res.data);
        
      }
    } catch (error) {
      console.error("Error checking venture state:", error);
    }
  };

  const checkUserStatus = async () => {
    const token = localStorage.getItem("verify_status");
    if (token === "false") {
      window.location.href = "/verify-email";
    }
  };

  const getUserStatus = async () => {
    try {
      const res = await axiosInstance.get("/auth/me");
      const isVerified = res.data.data.is_verified_email;
      const userEmail = res.data.data.email;
      const userId = res.data.data.id;

      localStorage.removeItem("verify_username");
      localStorage.setItem("verify_status", isVerified ? "true" : "false");
      // localStorage.setItem("verify_id", userId);

      if (!isVerified) {
        // Redirect to verify email page if not verified
        window.location.href = "/verify-email";
        return false;
      }
      return true;
    } catch (error) {
      localStorage.setItem("verify_status", "false");
      window.location.href = "/verify-email";
      return false;
    }
  };

  useEffect(() => {
    checkUserStatus();
    checkVentureState();
    getUserStatus();
  }, []);

  const userId = useSelector((state: RootState) => state.user.id);

  // 👇 Fetch user profile only if logged in and user data is missing
  useEffect(() => {
    if (token && !userId) {
      dispatch(fetchUserProfile());
    }
  }, [token, userId, dispatch]);

  // useEffect(()=> {
  //   dispatch(logout());
  //   dispatch(clearUser());
  //   window.location.href = "/login";
  // })

  // Extract card data from dashboardData
  const cardItems: CardItem[] = dashboardData
    ? [
        {
          text: "Total Completed Orders",
          figure:
            dashboardData.orders?.summary_by_status?.delivered?.count || 0,
          img: TruckTick,
        },
        {
          text: "Total Ongoing Orders",
          figure: dashboardData.orders?.summary_by_status?.pending?.count || 0,
          img: TruckTick,
        },
        {
          text: "Total Amount Earned",
          figure: `$${
            dashboardData.orders?.total_revenue?.toLocaleString() || 0
          }`,
          img: DCard,
        },
      ]
    : [];

  return (
    <div className="dashboard">
      <TitleComponent title="Dashboard" />
      {loading ? (
        <div style={{ textAlign: "center", margin: "2rem 0" }}>Loading...</div>
      ) : (
        <>
          <div className="dashboard__cards-container">
            {cardItems.map((item, index) => (
              <DashboardCard
                key={index}
                item={{
                  title: item?.text,
                  value: item?.figure,
                  img: item?.img,
                }}
              />
            ))}
          </div>

          <div className="dashboard__analytics">
            <div className="d1">
              <div className="dashboard__trend">
                <TrendChart />
              </div>

              <div className="dashboard__donut">
                <GuageChart value={65} label="Claim Rate" />
              </div>
            </div>

            <div className="dashboard__rank">
              <DashboardRank />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
